import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { compose } from 'redux';
import Clickable from '../../../Clickable/Clickable';
import Link from '../../../Link/Link';
import s from './Tile.scss';
import { mapLinkToDisplayCatalog } from '../../../../helpers/url';

const Tile = ({ title, text, link, image, buttonText, className }) => {
  const mappedLink = mapLinkToDisplayCatalog(link);
  const backgroundImage = image
    ? { backgroundImage: `url(${image.source})` }
    : null;
  return (
    <li className={cx(s.tile, className)} style={backgroundImage}>
      {title && <h3 className={s.title}>{title}</h3>}
      {text && <p className={s.text}>{text}</p>}
      {link && buttonText && (
        <Clickable primary link={<Link to={mappedLink} />}>
          {buttonText}
        </Clickable>
      )}
    </li>
  );
};

Tile.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
  buttonText: PropTypes.string,
  image: PropTypes.shape({
    source: PropTypes.string,
    thumbnail: PropTypes.string,
  }),
  className: PropTypes.string,
};

Tile.defaultProps = {
  title: null,
  text: null,
  link: null,
  buttonText: null,
  image: null,
  className: null,
};
export default compose(withStyles(s))(Tile);
